module.exports = __webpack_public_path__ + "static/media/MultisegmentalFlexionMale.49a9f5a9.svg";